import React from "react";
import { toAbsoluteUrl } from "../../helpers/Reusable";

const Location = () => {
  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson mb-[1%] text-center heading">Location</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="mb-[5%]">
            <h1 className="location-title">Mumbai (India)</h1>
            <p className="mb-[5%] location-para">
              112/11, Kamdhenu, Yamuna CHS, Hariom Nagar, Mulund East, Mumbai
              Maharashtra, India Code 400081. Landmark - Opposite Nalanda
              School.
            </p>
            <div className="w-full h-[20rem] sm:h-[30rem] lg:h-[40rem] mx-auto map-box">
              {/* <iframe
                className="w-full h-full rounded-xl border-none outline-none map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7048746.242888635!2d85.59217629999999!3d30.38587055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3995b9ebef1235bd%3A0x3ae1297b70640201!2sHimalayas!5e0!3m2!1sen!2sin!4v1737353596326!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe> */}
              <iframe
              className="w-full h-full rounded-xl border-none outline-none map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7537.010411527347!2d72.96103161638014!3d19.173124191714948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b992021cf97f%3A0x3cf249e119e3404b!2sKamdhenu!5e0!3m2!1sen!2sin!4v1739254406158!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Location;
